import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { loadFont as loadMono } from "@remotion/google-fonts/JetBrainsMono";
import { loadFont as loadScript } from "@remotion/google-fonts/DancingScript";
import { SUBBRAND } from "../../../brand/theme";

const { fontFamily: mono } = loadMono("normal", { weights: ["500", "700", "800"] });
const { fontFamily: script } = loadScript("normal", { weights: ["700"] });

const H = SUBBRAND.worship;

export type HeavensWorshipProps = {
  title: string;
  scriptLine: string;
  subtitle: string;
};

export const HeavensWorship: React.FC<HeavensWorshipProps> = ({ title, scriptLine, subtitle }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const enter = spring({ frame, fps, config: { damping: 200 } });
  const scale = interpolate(enter, [0, 1], [0.92, 1]);
  const op = (a: number, b: number) => interpolate(frame, [a, b], [0, 1], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill
      style={{
        background: `radial-gradient(circle at 50% 38%, ${H.blue[1]} 0%, ${H.blue[0]} 72%)`,
        justifyContent: "center",
        alignItems: "center",
        fontFamily: mono,
      }}
    >
      <div style={{ textAlign: "center", transform: `scale(${scale})` }}>
        {/* HW monogram box (placeholder for real monogram asset) */}
        <div style={{ opacity: op(0, 18), display: "inline-block", border: `4px solid ${H.text}`, padding: "14px 26px", marginBottom: 56 }}>
          <span style={{ color: H.text, fontSize: 64, fontWeight: 800, letterSpacing: 2 }}>HW</span>
        </div>

        <div style={{ opacity: op(10, 28), color: H.text, fontSize: 84, fontWeight: 800, letterSpacing: 8 }}>
          {title}
        </div>

        <div style={{ opacity: op(20, 40), fontFamily: script, color: H.text, fontSize: 72, fontWeight: 700, marginTop: 8 }}>
          {scriptLine}
        </div>

        <div style={{ opacity: op(30, 50) * 0.9, color: H.text, fontSize: 28, fontWeight: 500, letterSpacing: 5, marginTop: 56 }}>
          {subtitle}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
